<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="700" scrollable>
			<v-card>
				<v-card-title class="text-body-1 pb-1">
					<span>Detail Armada</span>
					<span class="pl-2">{{ detailArmada.vehicle_registration_number }}</span>
				</v-card-title>
				<v-card-text class="black--text pb-3">
					<v-row class="mb-3">
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Tipe Kendaraan</div>
							<div class="">{{ detailArmada.vehicle_type | armadaType }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Brand</div>
							<div class="">{{ detailArmada.vehicle_brand }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Model</div>
							<div class="">{{ detailArmada.vehicle_model }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Warna</div>
							<div class="text-capitalize">{{ detailArmada.vehicle_color }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Tahun Produksi</div>
							<div class="">{{ detailArmada.vehicle_production_year }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Service</div>
							<div class="">Tiap {{ detailArmada.vehicle_maintenance_cycle_month }} Bulan</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Harga Service</div>
							<div class="">{{ detailArmada.vehicle_maintenance_expense | toRupiah }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Terakhir Service</div>
							<div class="">{{ detailArmada.vehicle_last_maintenance_date ? 'detailArmada.vehicle_last_maintenance_date | tanggal' : '-' }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Harga Jual</div>
							<div class="">{{ detailArmada.vehicle_depreciation_expense | toRupiah }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Lebar Maksimal</div>
							<div class="">{{ detailArmada.vehicle_max_width_centimeter }} cm</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Tinggi Maksimal</div>
							<div class="">{{ detailArmada.vehicle_max_height_centimeter }} cm</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Kedalaman Maksimal</div>
							<div class="">{{ detailArmada.vehicle_max_depth_centimeter }} cm</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Berat Maksimal</div>
							<div class="">{{ detailArmada.vehicle_max_weight_kilogram | toKg }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Maksimal Tangki</div>
							<div class="">{{ detailArmada.vehicle_max_fuel_liter }} liter</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Bahan Bakar</div>
							<div class="">{{ detailArmada.vehicle_fuel_type }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Terakhir Beroprasi</div>
							<div class="">{{ detailArmada.vehicle_last_run_datetime ? 'detailArmada.vehicle_last_run_datetime | tanggal' : '-' }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Jumlah Beroprasi</div>
							<div class="">{{ detailArmada.vehicle_run_count }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Kondisi</div>
							<div class="">{{ detailArmada.vehicle_condition | armadaCondition }}</div>
						</v-col>
						<v-col cols="6" md="3">
							<div class="grey--text text--darken-2">Aktif</div>
							<div class="d-flex">
								<v-icon small color="green" v-if="detailArmada.vehicle_is_active == 'active'">mdi-check-circle</v-icon>
								<v-icon small color="red" v-else>mdi-close-circle</v-icon>
								<div class="pl-2">{{ (detailArmada.vehicle_is_active == 'active') ? 'Aktif' : 'Tidak Aktif' }}</div>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="modalHide">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false
		}
	},
	computed:{
		...mapState('armada', ['detailArmada']),

	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		
	}
};
</script>